import React from "react";

import { Col, Row } from "react-bootstrap";

import RatingsTable from "./RatingsTable";

import { RatingsProps } from "../types/myschedule";

const Ratings = (props: RatingsProps): React.JSX.Element => {
    return (
        <Row>
            <Col md={6} xl={{ span: 5, offset: 1 }}>
                <RatingsTable type="current" ratings={props.current} />
            </Col>
            <Col md={6} xl={5}>
                <RatingsTable type="previous" ratings={props.previous} />
            </Col>
        </Row>
    );
};

export default Ratings;
